import { Outlet, useOutletContext, useParams } from 'react-router-dom'

import { TrainingClassDetailIndexPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { SessionsDataTable } from './SessionsDatatable'

const SessionsTab = () => {
  const { classId, id } = useParams()
  const { canEdit } = useOutletContext<{ canEdit: boolean }>()
  const { data } = useQuery(TrainingClassDetailIndexPageDocument, {
    variables: { companyId: 0, trainingClassId: Number(classId), withFF: false },
  })

  const currentClass = data?.trainings.trainingClass ?? undefined
  return (
    <>
      <SessionsDataTable trainingClassId={Number(classId)} trainingId={Number(id)} />
      <Outlet context={{ canEdit, currentClass, id, classId }} />
    </>
  )
}

export default SessionsTab
